import * as bd from 'react-basic-design';
import { accountApi } from '../../../api/account-api';
import SvgDelete from '../../../assets/icons/Delete';
import SvgDevices from '../../../assets/icons/Devices';
import { calendar } from '../../../components/basic/calendar';
import { notify } from '../../../components/basic/notify';
import { T } from '../../../components/basic/text';
import { useWaiting } from '../../../components/basic/use-waiting';
import { SectionTitle } from '../../../components/ui/section-title';

export const UserDevicesInfo = ({ devices, onDelete }) => {
    const waiting = useWaiting();

    const getCurrentDevices = () => {
        const currentDevice = devices.filter(x => x.ip === devices.current)[0];
        if (!currentDevice) return <></>;

        const style = { flexDirection: 'row' };
        return (
            <bd.Flex
                className="card shadow-3 text-success"
                content="between"
                align="center"
                style={style}
            >
                <bd.Flex className="p-2 m-s-auto">
                    <SvgDevices />
                </bd.Flex>
                <bd.Flex className="p-s-3 m-l-1 row ltr">
                    <small className="mx-4"> {'Device : ' + currentDevice.device}</small>
                    <small className="mx-4">
                        {'Create At : ' + calendar.dateToString(currentDevice.createdAt)}
                    </small>
                </bd.Flex>
                <bd.Flex className="p-2 row ltr">
                    <small>{'Browser : ' + currentDevice.browser}</small>
                    <small>{'IP : ' + currentDevice.ip}</small>
                    <small> {'OS : ' + currentDevice.os}</small>
                </bd.Flex>
            </bd.Flex>
        );
    };

    const closeDeviceSesseion = session => {
        bd.msgbox(<T>delete-user-session</T>, <T>delete-user-session-description</T>, [
            {
                title: <T>delete</T>,
                variant: 'contained',
                color: 'secondary',
                className: 'min-w-80',
                action: hide => {
                    waiting.start();
                    accountApi
                        .DeleteUserSession(session.id)
                        .then(() => {
                            onDelete(session.id);
                            notify.success(<T>successfully-deleted-user-session</T>);
                        })
                        .catch(notify.error)
                        .finally(waiting.stop);
                    hide();
                },
            },
            {
                title: <T>cancel</T>,
                variant: 'outline',
                color: 'secondary',
            },
        ]);
    };

    const style = { flexDirection: 'row' };

    if (!devices)
        return (
            <div className="d-flex justify-content-center align-items-center alert alert-danger">
                <T className="small text-danger m-s-2">not-found-any-item</T>
            </div>
        );

    return (
        <div>
            <SectionTitle className="mt-3" title="connected-devices" />

            <>
                {getCurrentDevices()}

                {devices
                    .filter(session => session.ip !== devices.current)
                    .map(session => (
                        <>
                            <bd.Flex
                                className="card shadow-2 my-3 text-muted"
                                content="between"
                                align="center"
                                style={style}
                            >
                                <bd.Button
                                    variant="icon"
                                    size="sm"
                                    color="secondary"
                                    className="p-2 m-s-auto"
                                    onClick={() => closeDeviceSesseion(session)}
                                >
                                    <SvgDelete />
                                </bd.Button>
                                <bd.Flex className="p-s-3 m-l-1 row ltr">
                                    <small className="mx-5"> {'Device : ' + session.device}</small>
                                    <small className="mx-5">
                                        {'Create At : ' + calendar.dateToString(session.createdAt)}
                                    </small>
                                </bd.Flex>
                                <bd.Flex className="p-2 row ltr">
                                    <small>{'Browser : ' + session.browser}</small>
                                    <small>{'IP : ' + session.ip}</small>
                                    <small> {'OS : ' + session.os}</small>
                                </bd.Flex>
                            </bd.Flex>
                        </>
                    ))}
            </>
        </div>
    );
};
